import { render } from "./CommaNumber.vue?vue&type=template&id=fbad6394&ts=true"
import script from "./CommaNumber.vue?vue&type=script&lang=ts"
export * from "./CommaNumber.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__